<template>
  <div class="str-concat-container">
    <div class="tools_desc">
      <h1>字符串拼接</h1>
      <p>纯前端实现，输入内容不会储存，输入后自动拼接</p>
      <div class="input_container">
        <el-input
          size="medium"
          type="textarea"
          :rows="20"
          v-model="inputText"
          class="textarea"
        >
        </el-input>
        <el-row :gutter="15">
          <el-col :xs="24" :lg="12">
            <el-input type="text" v-model="delimiter">
              <template slot="prepend">连接符：</template>
            </el-input>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-input v-model="wrapper">
              <template slot="prepend">包裹符：</template>
            </el-input>
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-input v-model="header"
              ><template slot="prepend">头 部：</template></el-input
            >
          </el-col>
          <el-col :xs="24" :lg="12">
            <el-input v-model="footer"
              ><template slot="prepend">尾 部：</template></el-input
            >
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="str-concat">
      <div
        v-if="concatenatedString"
        class="result_container"
        style="
          width: 100vw;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        "
      >
        <div class="copyBtn">
          <el-button type="primary" @click="copyResult">复制结果</el-button>
        </div>
        <p class="concatResult">
          {{ concatenatedString }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StrConcat",
  metaInfo: {
    title: "字符串拼接", // 设置页面标题
    meta: [
      { name: "description", content: "将多行字符串自定包裹符连接符进行拼接" } // 设置页面描述
    ]
  },
  data() {
    return {
      inputText: "",
      delimiter: ",",
      wrapper: "'",
      header: "(",
      footer: ")"
    };
  },
  computed: {
    concatenatedString() {
      if (!this.inputText.trim()) return "";
      // 按换行符进行分割并且去除空行
      const lines = this.inputText
        .split("\n")
        .filter(line => line.trim().length > 0);
      // 使用包裹符包裹item
      const wrappedLines = lines.map(
        line => `${this.wrapper}${line.trim()}${this.wrapper}`
      );
      // 使用连接符进行拼接
      const result = wrappedLines.join(this.delimiter);
      // 追加头部尾部
      return `${this.header}${result}${this.footer}`;
    }
  },
  methods: {
    copyResult() {
      if (!this.concatenatedString) {
        // 如果没有字符串可复制，则不执行操作
        console.log("没有字符串可复制");
        return;
      }

      navigator.clipboard
        .writeText(this.concatenatedString)
        .then(() => {
          // 复制成功后的回调
          this.$message({
            message: "复制成功",
            type: "success",
            offset: 100
          });
        })
        .catch(err => {
          // 复制失败的回调
          this.$message.error("复制失败");
        });
    }
  }
};
</script>

<style scoped>
.str-concat-container {
  display: flex;
  flex-direction: column; /* 修改布局方向为垂直 */
  /* justify-content: center; 水平居中 */
  align-items: center; /* 垂直居中 */
  text-align: center; /* 将文本内容居中对齐 */
  justify-content: flex-start;
  min-height: calc(100vh - 160px);
}
.concatResult {
  word-wrap: break-word;
  padding: 0 40px;
}
.input_container {
  width: 600px;
}
.textarea {
  margin-bottom: 10px;
}

.el-row {
  margin: 10px 0;
}
.el-col {
  margin-bottom: 10px;
}
>>> .el-input-group__prepend {
  width: 80px;
  background-color: #67c23a;
  color: #fff;
  font-size: 16px;
}

.copyBtn {
  margin-top: 20px;
}
@media screen and (max-width: 540px) {
  .input_container {
    width: 80%;
    margin: 0 auto 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StrConcat.vue